import { useState, useEffect } from 'react';
import { Property } from '../types/user';
import { getProperties, createProperty, updateProperty, deleteProperty } from '../services/properties';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export const useProperties = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchProperties = async () => {
    try {
      const data = await getProperties();
      setProperties(data);
    } catch (error) {
      console.error('Error al cargar propiedades:', error);
      toast.error('Error al cargar las propiedades');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateProperty = async (data: { name: string; location: string }) => {
    try {
      const newProperty = await createProperty({
        name: data.name,
        location: data.location,
        stats: {
          revenue: 0,
          cleaningCosts: 0,
          inmohostCosts: 0,
          profit: 0,
          occupancyRate: 0,
          reservations: 0,
          averageNightPrice: 0,
          averageStayDuration: 0
        }
      });
      toast.success('Propiedad creada correctamente');
      await fetchProperties();
      navigate(`/property/${newProperty.id}?tab=stats`);
      return newProperty;
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al crear la propiedad');
      throw error;
    }
  };

  const handleUpdateProperty = async (property: Property) => {
    try {
      await updateProperty(property);
      toast.success('Propiedad actualizada correctamente');
      await fetchProperties();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al actualizar la propiedad');
      throw error;
    }
  };

  const handleDeleteProperty = async (id: string) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar esta propiedad?')) return;
    try {
      await deleteProperty(id);
      toast.success('Propiedad eliminada correctamente');
      await fetchProperties();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al eliminar la propiedad');
      throw error;
    }
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  return {
    properties,
    loading,
    createProperty: handleCreateProperty,
    updateProperty: handleUpdateProperty,
    deleteProperty: handleDeleteProperty
  };
};